import { cx } from "../utils/cx";

function Panel({ title, description, actions, className, children }) {
  return (
    <section className={cx("panel", className)}>
      {title || description || actions ? (
        <div className="panel-header">
          <div className="panel-copy">
            {title ? <h3 className="panel-title">{title}</h3> : null}
            {description ? <p className="panel-description">{description}</p> : null}
          </div>
          {actions ? <div className="panel-actions">{actions}</div> : null}
        </div>
      ) : null}

      <div className="panel-body">{children}</div>
    </section>
  );
}

export default Panel;
